
import Vue from 'vue';
import { Team, TeamMember } from '@run-diffusion/shared';
import { get$bindFirestoreOptions } from '@/mixins';
import { db } from '@/firebase';
import { mapGetters } from 'vuex';
import TeamMemberChip from './TeamMemberChip.vue';

export default Vue.extend({
	name: 'TeamMembersTableCell',
	props: {
		currTeam: {
			type: Object as () => Team,
			required: true,
		},
	},
	data() {
		return {
			teamMembers: [] as TeamMember[],
			teamMembersLoading: false,
		};
	},
	computed: {
		...mapGetters([
			'displayLabels',
		]),
		displayMembers(): TeamMember[] {
			return this.teamMembers.slice(0, 10);
		},
	},
	watch: {
		currTeam: {
			immediate: true,
			handler (newVal: Team, oldVal: Team) {
                const newTeamId: string = newVal?.id || null;
                const oldTeamId: string = oldVal?.id || null;
				if (newTeamId !== oldTeamId) {
					this.loadTeamMembers(newTeamId);
				}
			},
		},
	},
	methods: {
		async loadTeamMembers(teamId: string) {
            this.teamMembers = [];
			if (!teamId) return;

			this.teamMembersLoading = true;

			try {
                // index created: teamMembers - isAccepted Ascending email Ascending __name__ Ascending
				const teamMembersRef = db.collection(`teams/${teamId}/teamMembers`)
					.where('isAccepted', '==', true)
					.orderBy('email', 'asc')
					.limit(11);

				await this.$bind(
					'teamMembers',
					teamMembersRef,
					get$bindFirestoreOptions(),
				);
			} catch (error) {
				console.error('Error loading team members:', error);
			} finally {
				this.teamMembersLoading = false;
			}
		},
		onMoreClick() {
			this.$emit('view-all');
		},
	},
	components: {
		TeamMemberChip,
	},
});
